export default __webpack_public_path__ + "static/media/greenswapp_offset.0ce98835.svg";